<template>
    <v-dialog width="500" v-model="dialogo" persistent>
        <template slot="activator">
            <az-call-to-action active @click="exibirModalImportar" class="text-uppercase"
                               v-if="!this.$store.state.loki.asideClosed">
                <i class="fas fa-upload" aria-hidden="true"/>
                Importar
            </az-call-to-action>
            <v-tooltip right v-if="this.$store.state.loki.asideClosed">
                <a slot="activator" role="button" class="botao-menor secondary" @click="exibirModalImportar">
                    <i class="fas fa-upload" aria-hidden="true"/>
                </a>
                Importar Processo
            </v-tooltip>
        </template>

        <v-card v-if="mostrarModalImportar">
            <v-card-title class="primary modal-title" primary-title>
                <span>Importar dados do processo</span>
                <v-btn flat depressed @click="fecharModalImportar">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <v-container grid-list-md>
                    <v-layout wrap white>
                        <v-flex sm9 xs12>
                            <v-autocomplete
                                    v-model="processo"
                                    :items="numerosProcessosValidos" placeholder="Ex. 000.000.123/2019"
                                    :item-text="formataNumeroComSigla"
                                    name="Número do Processo" label="Número do Processo" v-validate="'required'"
                                    required :error-messages="errors.collect('Número do Processo')"
                                    :search-input.sync="buscarAutocomplete"
                                    ref="processoAutocomplete"
                                    id="processoAutocomplete"
                                    return-object
                            />
                        </v-flex>
                        <v-flex sm3 xs12 class="text-xs-center">
                            <az-call-to-action @click="importarNumeroProcesso" slot="actions"
                                               css-class="action-primary">
                                Importar
                            </az-call-to-action>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import {actionTypes} from '@/core/constants'

export default {
    name: 'ImportarProcesso',
    $_veeValidate: {
        validator: 'new'
    },
    data() {
        return {
            mostrarModalImportar: false,
            processo: {
                required: true
            },
            dialogo: false,
            numerosProcessosValidos: [],
            buscarAutocomplete: null
        }
    },
    methods: {
        async importarNumeroProcesso() {
            const validado = await this.$validator.validate('Número do Processo')
            if (!validado) {
                return
            }

            this.habilitarLoadingGlobal()
            this.setMensagemLoading('Importando o número do processo...')
            try {
                const resposta = await this.$store.dispatch(actionTypes.IMPORTAR_PROCESSO, this.processo)
                this.fecharModalImportar()
                this.limparCampoModal()
                this.mostrarNotificacaoSucesso('Número de processo importado com sucesso.')
                this.irParaExecucaoCompraDireta(resposta.id)
                this.desabilitarLoadingGlobal()
            } catch (e) {
                this.desabilitarLoadingGlobal()
                this.mostrarNotificacaoErro(e.message)
            }
        },
        irParaExecucaoCompraDireta(id) {
            this.$router.push({name: 'DadosGeraisEdicao', params: {id}})
        },
        exibirModalImportar() {
            this.mostrarModalImportar = true
            setTimeout(() => {
                this.focusInput()
            },600)
        },
        fecharModalImportar() {
            this.limparCampoModal()
            this.mostrarModalImportar = false
            this.dialogo = false
        },
        limparCampoModal() {
            this.processo = { required: true }
        },
        focusInput() {
            this.$refs.processoAutocomplete.focus()
        },
        formataNumeroComSigla(item) {
            return `${item.processo} - ${item.orgao}`
        }
    },
    watch: {
        async buscarAutocomplete(processo) {
            if (processo && processo.length > 1) {
                try {
                    this.desabilitarLoadingGlobal()
                    await this.$store.dispatch(actionTypes.COMPRADOR.BUSCAR_AUTOCOMPLETE_IMPORTAR_COMPRA_DIRETA, processo)
                    this.numerosProcessosValidos = this.$store.state.comprador.processosAutocomplete
                        .map(proc => ({ processo: proc.numero, orgao: proc.siglaOrgao }))

                    this.focusInput()
                } catch (e) {
                    this.mostrarNotificacaoErro(e.message)
                }
            }
        }
    }
}
</script>

<style scoped lang="stylus">
    .modal-title
        justify-content space-between

        span
            width 90%

        .v-btn
            padding 0
            margin 0
            color #fff
            box-sizing border-box
            min-width 25px

    .action-primary
        padding 10px 15px
        border 1px solid var(--v-primary-base)
        background-color var(--v-primary-base) !important
        color #fff !important
        width 100%
        box-sizing border-box

    .botao-menor
        color #fff
        border-radius 2px
        padding 5px 10px
        box-sizing border-box

        &:hover, &:focus, &:active
            background-color var(--v-primary-lighten1) !important

    @media (max-width 500px)
        .modal-title span
            width 80%
</style>
